module.exports = __webpack_public_path__ + "static/media/10_minutes.95629288.svg";